module.exports = "/_next/static/images/Dorin_Gora-481ee735d2389998fd12710e41f4c9de.webp";